/* Copyright (c) 2022-2024, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

export enum SsoIframeMessageType {
    READ = 'read',
    WRITE = 'write',
    DELETE = 'delete',
    SUCCESS = 'success',
    ERROR = 'error'
}

export const ssoLoginInfoBlockName = 'ssoLoginInfoEntry';
export const ssoLoginInfoFileName = 'loginids.json';

export enum LoginHintQueryKey {
    LoginHint = 'login_hint',
    IdpId = 'idp_id'
}

export enum ApplicationName {
    NVAPP = 'nvapp',
    GFN = 'gfn',
    GFN_WEB = 'gfn-web'
}

export interface SsoIframeMessageFormat {
    type?: SsoIframeMessageType;
    idp_id?: string;
    login_hint?: string;
    sub?: string;
    timestamp?: string;
}
export interface SsoLoginInfoEntry {
    applicationName?: string;
    idp_id?: string;
    login_hint?: string;
}
